import moment from 'moment';
import ListType from './converters/ListType';
import DTO from './DTO';
import {
  email,
} from '../utils/validation';
import DtoType from './converters/DtoType';
import AddressDTO from './AddressDTO';

class ZoneDTO extends DTO {
  constructor(params, isValidInit) {
    const attributes = [
      {
        name: 'id',
        type: String,
        validators: {},
        labelKey: 'zone.id',
      },
      {
        name: 'name',
        type: String,
        validators: {},
        labelKey: 'zone.name',
      },
      {
        name: 'save_all_fixation',
        type: Number,
        validators: {},
        labelKey: 'zone.save_all_fixation',
      },
      {
        name: 'address',
        type: DtoType(AddressDTO),
        validators: {},
        labelKey: 'zone.address',
      },
      {
        name: 'presets_ids',
        type: Array,
        validators: {},
        labelKey: 'presets_ids',
      },
      {
        name: 'ignore',
        type: Boolean,
        validators: {},
        labelKey: 'ignore',
      },
    ];
    super(attributes, params, isValidInit);
  }

  getData() {
    return {
      id: this.id,
      name: this.name,
      save_all_fixation: this.save_all_fixation,
      address: this.address.getData(),
      presets_ids: this.presets_ids,
      ignore: this.ignore,
    };
  }
}

export default ZoneDTO;
